/** Observe element size changes outside the ResizeObserver delivery frame. */
export function observeElementResize(
  elements: Element | Array<Element | null | undefined> | null | undefined,
  onResize: () => void,
): () => void {
  const targets = (Array.isArray(elements) ? elements : [elements])
    .filter((element): element is Element => !!element);
  if (typeof ResizeObserver === 'undefined' || targets.length === 0) {
    return () => {};
  }
  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = 0;
      onResize();
    });
  };
  const observer = new ResizeObserver(schedule);
  for (const target of targets) observer.observe(target);
  return () => {
    cancelAnimationFrame(frame);
    observer.disconnect();
  };
}
